module.exports = __webpack_public_path__ + "img/home-surveyoption.64ec5760.svg";